import Mooring from './Mooring';
export default class MooringArrivalData extends Mooring {
    distanceSinceEOSP;
    constructor(port, distanceSinceEOSP, freeText) {
        super(port, freeText);
        this.distanceSinceEOSP = distanceSinceEOSP;
    }
}
//# sourceMappingURL=MooringArrivalData.js.map